<template>
<div v-if="selectedLinks">
  <v-tabs v-model="tab" right :slider-color="sliderColor" background-color="transparent">
    <v-tabs-slider :color="sliderColor"></v-tabs-slider>

    <v-tab v-for="item in selectedLinks" :to="item.to" :key="item.text" >{{ item.text }}</v-tab>
  </v-tabs>
  
</div>
</template>

<script>
import _ from "lodash";


export default {
  name: "menu-tab",
  data() {
    return {
      tab: null,
     //selectedMenu:"Settings",
    //   selectedLinks:[
    //         {
    //           to: "/dashboard",
    //           icon: "mdi-view-dashboard",
    //           text: "Dashboard"
    //         },
    //         {
    //           to: "/dashboard",
    //           icon: "mdi-view-dashboard",
    //           text: "Menu"
    //         }
    //       ],
      menuItems: [
        {
          parent: "Settings",
          links: [
            {
              to: "/settings/profile",
              icon: "mdi-view-dashboard",
              text: "Profile"
            },
            {
              to: "/settings/users-and-teams",
              icon: "mdi-view-dashboard",
              text: "Users & Teams"
            },
            {
              to: "/settings/billing",
              icon: "mdi-view-dashboard",
              text: "Billing"
            }
          ]
        }, {
          parent: "Admin",
          links: [
            {
              to: "/admin/account",
              icon: "mdi-view-dashboard",
              text: "Account"
            },
            {
              to: "/admin/coverages",
              icon: "mdi-view-dashboard",
              text: "Coverages"
            }
          ]
        }
      ]
    };
  },
  computed: {
    sliderColor() {
      return this.$store.state.app.color;
    },
      selectedMenu() {
      return this.$store.state.app.selectedMenu;
    },
    selectedLinks(){
        return _.chain(this.menuItems).find({ parent: this.selectedMenu })
                .get("links")
              .value()
    },
  },
  watch: {
    sliderColor() {},
    selectedMenu(){}
  }
};
</script>

<style>
</style>